<template>
  <gmap-map
    id="map"
    :center="center"
    :zoom="13"
    :options="options"
    map-type-id="terrain"
  >
<GmapMarker
    :key="i"
    v-for="(m, i) in tableData"
    :position="m.position"
    :clickable="true"
    :icon="markerType(m.PRIORITE,m.DTE_DEBC)"
    @click="toggleInfoWindow(m,i)"
  />
<gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
      </gmap-info-window>markerType-->
      
  </gmap-map>



</template>
<script>
     import $ from 'jquery'
  import {API_KEY} from './Maps/API_KEY'
  import {BACKEND_URL} from './GLOBALS'
  import Vue from 'vue'
  import * as VueGoogleMaps from 'vue2-google-maps'
  Vue.use(VueGoogleMaps, {
    load: {
      key: API_KEY
    }
  })
  const markerOptionsgrey = require('@/assets/images/grey-dot.png');
  const markerOptionsred = require('@/assets/images/red-dot.png');
  const markerOptionsgreen = require('@/assets/images/green-dot.png');
  const markerOptionsyellow = require('@/assets/images/yellow-dot.png');
  const markerOptionsblue = require('@/assets/images/blue-dot.png');
  export default {
    data () {
      return {
        markerOptionsgrey: {
          url: markerOptionsgrey,
          size: {width: 40, height: 40, f: 'px', b: 'px',},
        },
        markerOptionsred: {
          url: markerOptionsred,
          size: {width: 40, height: 40, f: 'px', b: 'px',},
        },
        markerOptionsgreen: {
          url: markerOptionsgreen,
          size: {width: 40, height: 40, f: 'px', b: 'px',},
        },
        markerOptionsyellow: {
          url: markerOptionsyellow,
          size: {width: 40, height: 40, f: 'px', b: 'px',},
        },
        markerOptionsblue: {
          url: markerOptionsblue,
          size: {width: 40, height: 40, f: 'px', b: 'px',},
        },
        tableData:'',
        center: {
          lat: 46.8661971, lng: 1.4641031
        },
        options: {
          zoom: 5,
          styles: [{
            'featureType': 'water',
            'stylers': [{'saturation': 43}, {'lightness': -11}, {'hue': '#0088ff'}]
          }, {
            'featureType': 'road',
            'elementType': 'geometry.fill',
            'stylers': [{'hue': '#ff0000'}, {'saturation': -100}, {'lightness': 99}]
          }, {
            'featureType': 'road',
            'elementType': 'geometry.stroke',
            'stylers': [{'color': '#808080'}, {'lightness': 54}]
          }, {
            'featureType': 'landscape.man_made',
            'elementType': 'geometry.fill',
            'stylers': [{'color': '#ece2d9'}]
          }, {
            'featureType': 'poi.park',
            'elementType': 'geometry.fill',
            'stylers': [{'color': '#ccdca1'}]
          }, {
            'featureType': 'road',
            'elementType': 'labels.text.fill',
            'stylers': [{'color': '#767676'}]
          }, {
            'featureType': 'road',
            'elementType': 'labels.text.stroke',
            'stylers': [{'color': '#ffffff'}]
          }, {'featureType': 'poi', 'stylers': [{'visibility': 'off'}]}, {
            'featureType': 'landscape.natural',
            'elementType': 'geometry.fill',
            'stylers': [{'visibility': 'on'}, {'color': '#b8cb93'}]
          }, {'featureType': 'poi.park', 'stylers': [{'visibility': 'on'}]}, {
            'featureType': 'poi.sports_complex',
            'stylers': [{'visibility': 'on'}]
          }, {'featureType': 'poi.medical', 'stylers': [{'visibility': 'on'}]}, {
            'featureType': 'poi.business',
            'stylers': [{'visibility': 'simplified'}]
          }]
        },
          infoWindowPos: null,
          infoWinOpen: false,
          currentMidx: null,

          infoOptions: {
          content: '',
            pixelOffset: {
              width: 0,
              height: -35
            }
          },
      currentLocation : { lat : 0, lng : 0},
      searchAddressInput: ''
      }
    },
    computed: {
    },
    created() {
        $.ajaxSetup({
            data: {
              'sessionId': this.$store.getters.sessionId,
            },
          });
       var self= this
        var request = $.ajax({
            url: BACKEND_URL+"controller/suivi_actions.php",
            async: false,
            type: "POST",
            data: {
              getMapsAction:1
            },
            dataType: "html",
            success: function(data) {
              var dataParsed = JSON.parse(data)
                // if (self.$store.getters.restriction==1)
                //   self.tableData=dataParsed.listeActions.filter(data=>data.CDE_PROFIL==self.$store.getters.login)
                // else
                //  self.tableData=dataParsed.listeActions

                 switch(true){
                  case (self.$store.getters.restriction == 1 && self.$store.getters.vendeur !== null):
                    self.tableData = dataParsed.listeActions.filter(data =>data.CDE_PROFIL == self.$store.getters.login && data.VENDEUR == self.$store.getters.vendeur);
                    break;

                  case (self.$store.getters.restriction == 1 && self.$store.getters.vendeur == null):
                    self.tableData = dataParsed.listeActions.filter(data => data.CDE_PROFIL == self.$store.getters.login);
                    break;

                  case (self.$store.getters.restriction != 1 && self.$store.getters.vendeur !== null):
                    self.tableData = dataParsed.listeActions.filter(data => data.VENDEUR == self.$store.getters.vendeur);
                    break; 

                  default:
                    self.tableData = dataParsed.listeActions;
                    break;
                  }	

                console.log(self.tableData)
                for (var i = 0; i < self.tableData.length; i++) {

                  if (self.tableData[i].GEOCODE_X_CMDE==null || self.tableData[i].GEOCODE_Y_CMDE==null) {
                    let position =self.geocode(self.tableData[i].ADRESSE_COMPLETE_ACTION,'ayoub.belkadi@isoar.fr',self.tableData[i].CDE_CLI);
                    if(position!=0)
                    self.tableData[i].position=self.geocode(self.tableData[i].ADRESSE_COMPLETE_ACTION,'ayoub.belkadi@isoar.fr',self.tableData[i].CDE_CLI);
                  }else{
                    self.tableData[i].position={
                      lat: 40.748817,
                      lng: -73.985428
                    }

                    self.tableData[i].position["lat"]=parseFloat(self.tableData[i].GEOCODE_X_CMDE)
                    self.tableData[i].position["lng"]=parseFloat(self.tableData[i].GEOCODE_Y_CMDE)
                  }
                    self.tableData[i].infoOpened=false
                    self.tableData[i].infoText='<div>'
                    self.tableData[i].infoText+='<p><b>Action N° : </b>'
                    self.tableData[i].infoText+=self.tableData[i].NUM_ACTION
                    self.tableData[i].infoText+='</p>'
                    self.tableData[i].infoText+='<p><b>Adresse : </b>'
                    self.tableData[i].infoText+=self.tableData[i].ADRESSE_COMPLETE_ACTION
                    self.tableData[i].infoText+='</p>'
                    self.tableData[i].infoText+='<p><b>Début : </b>'
                      
                    self.tableData[i].infoText+=new Date(self.tableData[i].DTE_DEBC).toLocaleDateString("fr-FR")
                    self.tableData[i].infoText+='</p>'
                    self.tableData[i].infoText+='<p><b>Fin : </b>'
                    self.tableData[i].infoText+=new Date(self.tableData[i].DTE_FINC).toLocaleDateString("fr-FR")
                    self.tableData[i].infoText+='</p>'
                    self.tableData[i].infoText+='<hr><p><b><a href="#/admin/action?num_act='
                    self.tableData[i].infoText+=self.tableData[i].NUM_ACTION
                    self.tableData[i].infoText+='">Récapitulatif Actions</a>'
                    self.tableData[i].infoText+='</b></p>'
                    self.tableData[i].infoText+='</div>'
                    
                }
                self.geolocation()
            }
        })
    },
    mounted : function() {
 },
    methods: {

      markerType: function (PRIORITE,DTE_DEBC) {
        let is_dte_prev=(new Date(DTE_DEBC) < new Date())
            if (PRIORITE=='0') {
              return markerOptionsgreen
            }
            else if( PRIORITE=='1') {
              return markerOptionsyellow
            }else if( PRIORITE== '2' || is_dte_prev ){
             return markerOptionsred
            }
            else if( PRIORITE=='3') {
              return markerOptionsred
            }
            else if( PRIORITE=='9') {
              return markerOptionsblue
            }
              return markerOptionsblue
        },
          toggleInfoWindow: function(marker, idx) {
            this.infoWindowPos = marker.position;
            this.infoOptions.content = marker.infoText;

            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
              this.infoWinOpen = !this.infoWinOpen;
            }
            //if different marker set infowindow to open and reset current marker index
            else {
              this.infoWinOpen = true;
              this.currentMidx = idx;

            }
          },
          /*===============================Geocodage================================*/

 geocode(adresse,mail,cde_cli) {
       var self= this
    let position={}//la position à retournée
    $.ajax({//faire la requette ajax qui permet de recuperer le geocodage il faudra founire un mail valid
        //pour cette api il ne faut pas le header donc data ne dois pas etre mentionné
        url: 'https://maps.googleapis.com/maps/api/geocode/json?address='+adresse+'&key='+API_KEY, 
        type: 'GET',
       
        format:JSON,
        error: function() {
            position=0;
        },
        success: function(data) {
          
            if(data.results.length==0) position=0//si l'adresse entrer est vide
            else {

              data=data.results[0].geometry.location
            position["lat"]=parseFloat(data["lat"])
            position["lng"]=parseFloat(data["lng"])
            
            self.savePosGeoCodeClient(cde_cli,position["lat"],position["lng"])
            }

            }
    });
    return position
    },
    geolocation : function() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
                
    },
    savePosGeoCodeClient(cde_cli, x,y) {
        var request = $.ajax({
            url: BACKEND_URL+"controller/suivi_actions.php",
            async: false,
            type: "POST",
            data: {
              updateGeoPosAction:1,
              cde_cli:cde_cli,
              x:x,
              y:y
            },
            dataType: "html",
            success: function(data) {
          }
      });
    }
    },
  }
</script>
<style>
  #map {
    min-height: calc(100vh - 123px);
  }
</style>
